import {
  IModifyParamsToSend,
  IParamsToSend
} from '@base/@types/providers/Budget/store'
export const paramsReportToSendMapping = ({
  name,
  value,
  compareName,
  fieldName,
  paramsToSend
}: IModifyParamsToSend) => {
  const paramsToSendFormatted: IParamsToSend = { ...paramsToSend }

  if (name === compareName) {
    paramsToSendFormatted[fieldName] = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted[fieldName].agrupar,
      ids:
        typeof value === 'object'
          ? value.map(item => item.value)
          : paramsToSend[fieldName].ids
    }
  }

  return paramsToSendFormatted
}
